import api from '../utils/apiClient';

export async function listApps() {
  const res = await api.get('/api/admin/apps');
  return res.data;
}

export async function createApp(payload) {
  const res = await api.post('/api/admin/apps', payload);
  return res.data;
}

export async function updateApp(id, payload) {
  const res = await api.put(`/api/admin/apps/${id}`, payload);
  return res.data;
}

export async function deleteApp(id) {
  const res = await api.delete(`/api/admin/apps/${id}`);
  return res.data;
}

export async function getAppUsers(slug) {
  const res = await api.get(`/api/admin/apps/${slug}/users`);
  return res.data;
}

export async function getAppUsage(slug) {
  const res = await api.get(`/api/admin/apps/${slug}/usage`);
  return res.data;
}

export async function banAppUser(slug, userId, payload) {
  const res = await api.patch(`/api/admin/apps/${slug}/users/${userId}/ban`, payload);
  return res.data;
}

export async function getAllAppsOverview() {
  const res = await api.get('/api/admin/apps/overview/all');
  return res.data;
}
